import React from 'react';
import { Link } from 'react-router-dom';
import { Translate } from '../common/Translate';


export const Income = props => {

    const { subAktif, setSubAktif } = props;

    return (
        <div className="first-level__sub-items">
            <ul className="second-level">
                <li className="second-level__item">
                    <svg className="icon second-level__icon">
                        <use xlinkHref="../img/sprite.svg#icon-file-empty"></use>
                    </svg>
                    <Link  className={`second-level__definition${(subAktif === 'faturalar' ? ' active' : '')}`}  to="/invoice-list" onClick={e => { setSubAktif('faturalar'); }}>
                        <span className="second-level__span">
                            <Translate>Faturalar</Translate>
                        </span>
                    </Link>
                </li>
                <li className="second-level__item">
                    <svg className="icon second-level__icon">
                        <use xlinkHref="../img/sprite.svg#icon-file-text"></use>
                    </svg>
                    <Link className={`second-level__definition${(subAktif === 'crm-fatura' ? ' active' : '')}`} to="/crm-invoice-list" onClick={e => { setSubAktif('crm-fatura'); }}>
                        <span className="second-level__span">
                            <Translate>CRM Fatura</Translate>
                        </span>
                    </Link>
                </li>
                {/*   <li className="second-level__item">
                    <svg className="icon second-level__icon">
                        <use xlinkHref="../img/sprite.svg#icon-credit-card"></use>
                    </svg>
                    <Link className="second-level__definition" to="/collection-list">
                        <span className="second-level__span">
                            Tahsilatlar
                    </span>
                    </Link>
                </li> */}
            </ul>
        </div>
    )
}